export default __webpack_public_path__ + "static/orange-5129288ae2a83fe8d7a0eb0f8cd2cdf0.webp";